import { Button, DeleteIcon, Menu, MoreIcon, Space } from "melco-ui";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { useConfirm } from "melco-shared-logic";
import { useNavigate } from "react-router";
import { isEmpty } from "lodash-es";
import { useDeleteViews } from "../../../hooks/reporting/useDeleteViews";

type MachineStatusViewMoreActionButtonProps = {
  view: any;
};

export const MachineStatusViewMoreActionButton: React.FC<
  MachineStatusViewMoreActionButtonProps
> = ({ view }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deleteViews = useDeleteViews();

  const confirmDelete = useConfirm(
    async () => {
      if (view.id) {
        const successfullyDeletedIds = await deleteViews([view.id]);

        // // redirect to list view in case the entity was deleted successfully
        if (!isEmpty(successfullyDeletedIds)) {
          navigate(`/reporting/machine/status`);
        }
      }
    },
    {
      translationPrefix: "reporting.machinestatus.view.actions.delete",
      translationOptions: {
        count: 1,
      },
      content: (
        <Space direction="vertical" size="small">
          {t(
            "reporting.machinestatus.view.actions.delete.confirmation.message_one"
          )}
          {/* <Alert
            type="warning"
            withBackground
            description={t("views.actions.delete.confirmation.warning", {
              count: showWarningForRowKeys.length,
            })}
            showIcon={false}
          /> */}
        </Space>
      ),
    }
  );

  const MoreActions = (
    <Menu>
      <Menu.Item
        key="more-actions-delete"
        onClick={() => {
          confirmDelete();
        }}
        icon={<DeleteIcon />}
        data-cy-id="delete-view"
        danger
      >
        {t("reporting.machinestatus.view.actions.delete.button")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={MoreActions}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Button
        key="view-more-actions"
        icon={<MoreIcon />}
        data-cy-id="machine-status-view-more-actions"
      />
    </Dropdown>
  );
};
